import React, { StrictMode } from 'react';
import loadable from '@loadable/component';
import { Helmet } from 'react-helmet-async';
import { ImgSrcProvider } from '@moda/imgsrc';
import { CookiesProvider } from './hooks/useCookies';
import { ScrollToTop } from './components/ScrollToTop';
import { ReloadOnResetCache } from './components/ReloadOnResetCache';
import { ErrorModal } from './components/ErrorModal';
import { Loading } from './components/Loading';
import { DialogProvider } from './components/Dialog';
import { FavoritesProvider } from './components/Favorite/FavoritesProvider';
import { ApplePayProvider } from './components/ApplePay';
import { CONFIG } from './config';
import { Router } from './routers';
import { AuthenticationModal, AuthModalProvider } from './components/Authentication';

import './App.scss';

const ErrorPage = loadable(() => import('./pages/ErrorPage'), {
  fallback: <Loading />
});

type Props = {
  error?: boolean;
};

export const App = ({ error }: Props) => (
  <StrictMode>
    <ReloadOnResetCache>
      <ErrorModal />

      <ScrollToTop />

      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0" />
      </Helmet>

      <div className="App">
        <AuthModalProvider>
          <ImgSrcProvider
            configuration={{
              modaImgRoot: CONFIG.MODA_IMG_ROOT,
              isDisabled: CONFIG.ENABLE_IMG_RESIZING !== 'true'
            }}
          >
            <CookiesProvider>
              <FavoritesProvider>
                <DialogProvider>
                  <ApplePayProvider>
                    <AuthenticationModal />
                    {error ? <ErrorPage /> : <Router />}
                  </ApplePayProvider>
                </DialogProvider>
              </FavoritesProvider>
            </CookiesProvider>
          </ImgSrcProvider>
        </AuthModalProvider>
      </div>
    </ReloadOnResetCache>
  </StrictMode>
);
